'use client'
import WebinarCard from '@/components/atoms/WebinarCard/WebinarCard';
import LpBanner from '@/LpRevamp/LpBanner/LpBanner'
import React, { useEffect } from 'react'
interface WebinarProps {
    BannerData: any;
    isMobile: boolean;
    fetchPriority?: "auto" | "high";
    specializationText: string;
    Custom10PgType?: string;
    associatedPrograms: AssociatedProgram;
    ProgramId: string;
    NewBannerUI: NewBannerUI;
    isSeatsFilledEnabled: boolean;
    Numbers: number;
    isCampusImmersionPage?: boolean;
    isLambdaApi?: boolean;
    LandingPageBrochure?: any;
    NewBannerImage?:NewBannerImage;
    Webinar?:WebinarUI;
    slug?: string;
  }
const WebinarPage = ({
    BannerData,
    isMobile,
    specializationText,
    Custom10PgType = "",
    associatedPrograms,
    ProgramId,
    NewBannerUI,
    isSeatsFilledEnabled,
    NewBannerImage,
    Webinar,
    slug
  }:WebinarProps) => {
    const basicDetails = associatedPrograms?.[0]?.attributes?.BasicDetails || {};
    const { Brochure, Heading: title } = basicDetails;
    const match = slug?.match(/\/([a-z]+)-webinar/i);
    const result = match ? match[1] : null;
    const redirectionUrl = `${title?.toLowerCase()?.replace(/[^a-z0-9]+/g, '-')?.replace(/^-+|-+$/g, '')}-online`;
    useEffect(()=>{
      sessionStorage.setItem('title', result || '');
      sessionStorage.setItem('redirectionUrl', redirectionUrl);
    },[Webinar?.isEnabled])
  return (
    <>
      <LpBanner
        BannerData={BannerData}
        isMobile={isMobile}
        fetchPriority="high"
        specializationText={specializationText}
        Custom10PgType={Custom10PgType}
        associatedPrograms={[associatedPrograms[0]]}
        ProgramId={ProgramId}
        NewBannerUI={NewBannerUI}
        isSeatsFilledEnabled={isSeatsFilledEnabled}
        isLambdaApi={true}
        LandingPageBrochure={Brochure}
        NewBannerImage={NewBannerImage}
        Webinar={Webinar}
        slug={slug}
      />

      {Webinar?.ContentComponent?.map((item, index) => (
        <WebinarCard item={item} />
      ))}
    </>
  );
}

export default WebinarPage
